var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGbFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GB 1",
    clipPath: "url(#clip0_22029_903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.97548 13.951C10.8279 13.951 13.951 10.8279 13.951 6.97548C13.951 3.12303 10.8279 0 6.97548 0C3.12303 0 0 3.12303 0 6.97548C0 10.8279 3.12303 13.951 6.97548 13.951Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.4419 2.72852C0.893967 3.4414 0.480807 4.26307 0.240234 5.15568H3.86906L1.4419 2.72852Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.7108 5.15565C13.4702 4.26307 13.057 3.4414 12.5091 2.72852L10.082 5.15565H13.7108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.240234 8.79492C0.480834 9.68751 0.893995 10.5092 1.4419 11.222L3.86898 8.79492H0.240234Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.2221 1.44192C10.5092 0.893995 9.68754 0.480834 8.79492 0.240234V3.86904L11.2221 1.44192Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.72852 12.5091C3.4414 13.057 4.26307 13.4702 5.15565 13.7108V10.082L2.72852 12.5091Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.15563 0.240234C4.26304 0.480834 3.44138 0.893995 2.72852 1.4419L5.15563 3.86901V0.240234Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.79492 13.7108C9.68751 13.4702 10.5092 13.057 11.222 12.5091L8.79492 10.082V13.7108Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.082 8.79492L12.5091 11.2221C13.057 10.5092 13.4702 9.68751 13.7108 8.79492H10.082Z",
    fill: "#0052B4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M13.8919 6.06564H7.88537H7.88534V0.0590463C7.58749 0.0202725 7.28384 0 6.97548 0C6.66706 0 6.36346 0.0202725 6.06564 0.0590463V6.06559V6.06561H0.0590463C0.0202725 6.36346 0 6.66711 0 6.97548C0 7.2839 0.0202725 7.58749 0.0590463 7.88531H6.06559H6.06561V13.8919C6.36346 13.9307 6.66706 13.951 6.97548 13.951C7.28384 13.951 7.58749 13.9307 7.88531 13.8919V7.88537V7.88534H13.8919C13.9307 7.58749 13.951 7.2839 13.951 6.97548C13.951 6.66711 13.9307 6.36346 13.8919 6.06564Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M8.79492 8.79495L11.9076 11.9076C12.0508 11.7645 12.1873 11.6149 12.3176 11.4598L9.65274 8.79492H8.79492V8.79495Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M5.15569 8.79541H5.15564L2.04297 11.9081C2.18608 12.0512 2.33569 12.1878 2.49079 12.3181L5.15569 9.65315V8.79541Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M5.15554 5.15575V5.15569L2.04284 2.04297C1.89968 2.18608 1.76311 2.33569 1.63281 2.49079L4.29774 5.15572L5.15554 5.15575Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M8.79492 5.15605L11.9076 2.0433C11.7645 1.90014 11.6149 1.76357 11.4598 1.6333L8.79492 4.29823V5.15605Z",
    fill: "#D80027"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22029_903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.951,
    height: 13.951,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbFlag);
export default __webpack_public_path__ + "static/media/GB-flag.bcb937d4ba36ad4be36a186b7467f87f.svg";
export { ForwardRef as ReactComponent };